"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useForm = void 0;
var react_1 = __importDefault(require("react"));
var form_state_context_v2_1 = require("../context/form-state-context-v2");
var lodash_1 = require("lodash");
var useForm = function (formName) {
  var context = react_1.default.useContext(form_state_context_v2_1.FormStateContextV2);
  if (!context) {
    throw new Error('useFormStateV2 must be used within a FormStateProviderV2');
  }
  var patch = context.patchForm(formName);
  var formState = context.state[formName] || form_state_context_v2_1.defaultFormStateDefinition;
  var canSubmit = function () {
    if (!formState.isValid) {
      return false;
    }
    if (formState.canSubmit) {
      return formState.canSubmit();
    }
    return true;
  };
  var mutationValue = react_1.default.useMemo(function () {
    return (0, lodash_1.mapValues)(formState.fields, function (field) {
      return field.mutationValue;
    });
  }, [formState.fields]);
  var value = react_1.default.useMemo(function () {
    return (0, lodash_1.mapValues)(formState.fields, function (field) {
      return field.value;
    });
  }, [formState.fields]);
  return __assign(__assign({}, formState), {
    canSubmit: canSubmit,
    patch: patch,
    mutationValue: mutationValue,
    value: value,
    reset: function () {
      return patch(form_state_context_v2_1.defaultFormStateDefinition, 'replace');
    },
    resetFields: function () {
      return patch({
        fields: {}
      }, 'replace');
    },
    patchFields: function (fieldsPatch) {
      return patch({
        fields: fieldsPatch
      });
    }
  });
};
exports.useForm = useForm;